<template>
  <v-container grid-list-lg fluid>
    <v-layout row wrap>
      <v-flex xs12>
        <v-card class="elevation-3">
          <v-card-text>
            <v-layout justify-center align-center>
              <v-flex xs12>
                <pivot
                  fields-label-text="Filtros activos"
                  columns-label-text="Columnas activas"
                  available-colums-label-text="Columnas disponibles"
                  available-fields-label-text="Filtros disponibles"
                  :data="data"
                  :filters="filters"
                  :fields-list="lists.fieldsList"
                  :columns-list="lists.columnsList"
                  :default-columns="defaultColumns"
                  @loading="clearData"
                  @loaded="setData">
                </pivot>
              </v-flex>
            </v-layout>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
  import Pivot from '@/components/global/report_datatables/Pivot';

  export default {
    components: {
      Pivot,
    },
    data() {
      return {
        dialog: false,
        data: [],
        filters: {
          type: 'daily',
          type_id: 4,
          date: '2019-06-11',
        },
        defaultColumns: [
          {
            label: 'Total',
            value: 'quantity',
          },
        ],
        lists: {
          fieldsList: [
            {
              label: 'Agencia',
              value: 'agency',
            },
            {
              label: 'Tramo',
              value: 'tranche',
            },
            {
              label: 'Vencimiento',
              value: 'due_day',
            },
            {
              label: 'Portafolio',
              value: 'portfolio_type',
            },
            {
              label: 'Tipo de cuenta',
              value: 'account_type',
            },
            {
              label: 'Agente',
              value: 'agent',
            },
            {
              label: 'Genero',
              value: 'gender',
            },
            {
              label: 'Grupo de edad',
              value: 'age_group',
            },
          ],
          columnsList: [
            {
              label: 'Balance',
              value: 'balance',
            },
          ],
        },
      };
    },
    methods: {
      clearData() {
        this.data = [];
        this.isDataLoading = true;
      },
      setData($event) {
        this.data = $event;
        this.isDataLoading = false;
      },
    },
  };
</script>



// WEBPACK FOOTER //
// src/components/reports/load/Index.vue